<!-- YETKİSİZ ERİŞİM: Bilinmeyen kart -->
<div class="yetkisiz-sayfa">
  <div class="yetkisiz-bg">
    <div class="yetkisiz-scan-line"></div>
    <div class="yetkisiz-grid-overlay"></div>
  </div>
  <div class="yetkisiz-icerik">
    <div class="yetkisiz-ikon-wrap">
      <div class="yetkisiz-ring r1"></div>
      <div class="yetkisiz-ring r2"></div>
      <div class="yetkisiz-ring r3"></div>
      <div class="yetkisiz-ring r4"></div>
      <div class="yetkisiz-kalkan">
        <span class="yetkisiz-kalkan-ikon">🚫</span>
      </div>
    </div>
    <div class="yetkisiz-baslik">
      <span class="yetkisiz-harf" style="animation-delay:0s">Y</span>
      <span class="yetkisiz-harf" style="animation-delay:0.05s">E</span>
      <span class="yetkisiz-harf" style="animation-delay:0.1s">T</span>
      <span class="yetkisiz-harf" style="animation-delay:0.15s">K</span>
      <span class="yetkisiz-harf" style="animation-delay:0.2s">İ</span>
      <span class="yetkisiz-harf" style="animation-delay:0.25s">S</span>
      <span class="yetkisiz-harf" style="animation-delay:0.3s">İ</span>
      <span class="yetkisiz-harf" style="animation-delay:0.35s">Z</span>
      <span class="yetkisiz-bosluk"></span>
      <span class="yetkisiz-harf" style="animation-delay:0.45s">E</span>
      <span class="yetkisiz-harf" style="animation-delay:0.5s">R</span>
      <span class="yetkisiz-harf" style="animation-delay:0.55s">İ</span>
      <span class="yetkisiz-harf" style="animation-delay:0.6s">Ş</span>
      <span class="yetkisiz-harf" style="animation-delay:0.65s">İ</span>
      <span class="yetkisiz-harf" style="animation-delay:0.7s">M</span>
    </div>
    <div class="yetkisiz-alt">Bu kart sisteme kayıtlı değildir</div>
    <div class="yetkisiz-detay">
      <div class="yetkisiz-detay-item">
        <span class="yetkisiz-detay-ikon">🔒</span>
        <span>Erişim Reddedildi</span>
      </div>
      <div class="yetkisiz-detay-item">
        <span class="yetkisiz-detay-ikon">📋</span>
        <span>Olay Kaydedildi</span>
      </div>
      <div class="yetkisiz-detay-item">
        <span class="yetkisiz-detay-ikon">👤</span>
        <span>Yönetici Bilgilendirildi</span>
      </div>
    </div>
    <div class="yetkisiz-timer">Kartı çıkararak ekranı sıfırlayın</div>
  </div>
</div>
